import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPanel.css";
import AdminSidebar from "./AdminSidebar";
import AdministratorSidebar from "./AdministratorSidebar";
import UserSidebar from "./UserSidebar";

const CreateVolet = () => {
    const navigate = useNavigate();
    const [userType, setUserType] = useState("");
    const [userName, setUserName] = useState("");
    const [userFullName, setUserFullName] = useState("");
    const [clients, setClients] = useState([]);
    const [formData, setFormData] = useState({
        client_id: "",
        date: new Date().toISOString().split('T')[0],
        payment_method: "",
        currency: "USD",
        conversion_rate: "1",
        received_amount: ""
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    useEffect(() => {
        const storedUserType = localStorage.getItem("usertype");
        const storedUserName = localStorage.getItem("userName");
        const storedFName = localStorage.getItem("fname");
        const storedLName = localStorage.getItem("lname");

        if (!storedUserType) {
            navigate("/login");
        } else {
            setUserType(storedUserType);
            setUserName(storedUserName);
            if (storedFName && storedLName) {
                setUserFullName(`${storedFName} ${storedLName}`);
            } else if (storedFName) {
                setUserFullName(storedFName);
            } else {
                setUserFullName(storedUserName);
            }
        }
    }, [navigate]);

    useEffect(() => {
        fetchClients();
    }, []);

    const fetchClients = async () => {
        try {
            const response = await fetch("https://skcapi.btcjapan.co/fetchclients.php");
            const data = await response.json();
            setClients(data);
        } catch (error) {
            console.error("Error fetching clients:", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setSuccess("");

        try {
            const response = await fetch("https://skcapi.btcjapan.co/updatevolet.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (response.ok) {
                setSuccess(data.message || "Payment record created successfully!");
                setFormData({
                    client_id: "",
                    date: new Date().toISOString().split('T')[0],
                    payment_method: "",
                    currency: "USD",
                    conversion_rate: "1",
                    received_amount: ""
                });
            } else {
                setError(data.message || "Failed to create payment record");
            }
        } catch (err) {
            setError("An error occurred while submitting the form");
            console.error("Submission error:", err);
        } finally {
            setLoading(false);
        }
    };

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("email");
        localStorage.removeItem("userName");
        localStorage.removeItem("usertype");
        localStorage.removeItem("fname");
        localStorage.removeItem("lname");
        navigate("/login");
    };

    return (
        <div className="admin-container">
            <div className="sidebar-container">
                {userType === "administrator" && <AdministratorSidebar />}
                {userType === "admin" && <AdminSidebar />}
                {userType === "user" && <UserSidebar />}
            </div>

            <div className="admin-content">
                <div className="admin-navbar">
                    <h1 className="welcome-text">Welcome to the Admin Panel, {userFullName}</h1>
                    <button onClick={logout} className="logout-btn btn btn-warning">
                        Logout
                    </button>
                </div>

                <div className="mainsection">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className='section-title text-center'>Create New Payment</h3>
                        <button 
                            onClick={() => navigate("/volet")} 
                            className="btn btn-secondary"
                        >
                            Back to View Payments
                        </button>
                    </div>

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                    )}
                    {success && (
                        <div className="alert alert-success" role="alert">
                            {success}
                        </div>
                    )}

                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="client_id" className="form-label">Client Name</label>
                                    <select
                                        className="form-select"
                                        id="client_id"
                                        name="client_id"
                                        value={formData.client_id}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select a client</option>
                                        {clients.map(client => (
                                            <option key={client.id} value={client.id}>
                                                {client.name} ({client.username})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="date" className="form-label">Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="date"
                                        name="date"
                                        value={formData.date}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="payment_method" className="form-label">Payment Method</label>
                                    <select
                                        className="form-select"
                                        id="payment_method"
                                        name="payment_method"
                                        value={formData.payment_method}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select payment method</option>
                                        <option value="bank_transfer">Bank Transfer</option>
                                        <option value="credit_card">Credit Card</option>
                                        <option value="paypal">PayPal</option>
                                        <option value="cash">Cash</option>
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="currency" className="form-label">Currency</label>
                                    <select
                                        className="form-select"
                                        id="currency"
                                        name="currency"
                                        value={formData.currency}
                                        onChange={handleChange}
                                    >
                                        <option value="USD">USD</option>
                                        <option value="EUR">EUR</option>
                                        <option value="JPY">JPY</option>
                                        <option value="GBP">GBP</option>
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="conversion_rate" className="form-label">Conversion Rate (to USD)</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="conversion_rate"
                                        name="conversion_rate"
                                        value={formData.conversion_rate}
                                        onChange={handleChange}
                                        step="0.0001"
                                        min="0"
                                        placeholder="Enter conversion rate to USD"
                                        required
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="received_amount" className="form-label">Received Amount (USD)</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        id="received_amount"
                                        name="received_amount"
                                        value={formData.received_amount}
                                        onChange={handleChange}
                                        step="0.01"
                                        min="0"
                                        placeholder="Optional"
                                    />
                                </div>

                                <button type="submit" className="btn btn-primary" disabled={loading}>
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            <span className="visually-hidden">Loading...</span>
                                            Submitting...
                                        </>
                                    ) : (
                                        "Submit Payment"
                                    )}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateVolet;